import type { AgencyCategory } from '@saaga/shared/interfaces/agencies.interface'
import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

import { agencyCategoryLabelMap } from './agencies.mock'

interface AgencyCategoryFilterProps {
  categoryList: AgencyCategory[]
  selectedCategoryList: AgencyCategory[]
  onCategoryToggle: (category: AgencyCategory) => void
  onClearAll?: () => void
  className?: string
}

export const AgencyCategoryFilter = ({
  categoryList,
  selectedCategoryList,
  onCategoryToggle,
  onClearAll,
  className,
}: AgencyCategoryFilterProps): ReactNode => {
  const hasSelection = selectedCategoryList.length > 0

  const handleAllClick = (): void => {
    onClearAll?.()
  }

  return (
    <div className={cn('agency-category-filter flex flex-wrap items-center gap-2', className)}>
      <Badge
        variant={hasSelection ? 'outline' : 'default'}
        className={cn(
          'agency-category-filter-all cursor-pointer transition-colors',
          !hasSelection && 'pointer-events-none'
        )}
        onClick={handleAllClick}
      >
        All
      </Badge>
      {categoryList.map((category) => {
        const isSelected = selectedCategoryList.includes(category)
        return (
          <Badge
            key={category}
            variant={isSelected ? 'default' : 'outline'}
            className="agency-category-filter-item cursor-pointer transition-colors hover:bg-primary/90"
            onClick={() => onCategoryToggle(category)}
          >
            {agencyCategoryLabelMap[category]}
          </Badge>
        )
      })}
    </div>
  )
}
